import * as React from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import { ComposedActions } from '../../../helpers/actions';
import { uiWindowBtnClickAC } from '../../../store/actions/executor.actions';
import {
    IVideoPanelButton, IVideoPanelButtonDict, IVideoPanelItem
} from '../../../types/VideoPanelDefs';
import Row from '../../S80/components/common/Row';

/*
 * This component is the button panel on the top right in the main window
 */

export interface IWindowsMenuProps {
  panelRows: Array<IVideoPanelItem>;
  buttonDict: IVideoPanelButtonDict;
}

const StyledWindowsMenu = styled.div`
  display: flex;
  min-height: 100%;
  flex-direction: column;
  border: 2px ridge #ffffff;
`;

const RowContainer = styled(Row as any)`
  flex-grow: 1;
  justify-content: space-between;
`;

const LabelContainer = styled.div`
  flex-grow: 1;
  flex-shrink: 0;
  text-align: center;
`;

const StyledButton = styled.button<IVideoPanelButton>`
  display: flex;
  flex: 1;
  margin: 4px;
  justify-content: space-between;
  align-items: center;
  padding: 0 5px;
  font-size: 14px;
  background: rgb(48, 143, 88);
  border-color: rgb(170, 170, 170) rgb(0, 0, 0) rgb(0, 0, 0) rgb(170, 170, 170);
  color: rgb(255, 255, 255);
  border-width: 2px;
  border-style: outset;

  :focus {
    outline: none;
  }
  :active {
    border-color: rgb(0, 0, 0) rgb(170, 170, 170) rgb(170, 170, 170)
      rgb(0, 0, 0);
  }
  img {
    width: 30%;
    object-fit: contain;
  }
  cursor: pointer;

  ${({ visible, defaultValue }) => `
        display: ${visible === 'true' ? 'inline-flex' : 'none'};
        ${
          defaultValue === 'OFFLINE' &&
          `
        border-color: transparent;
        background: transparent;
        color: #a7a7a7;
        cursor: not-allowed;
        :active {
          border-color:transparent;
        }
        `
        };
        ${
          (defaultValue === 'UNKNOWN' || defaultValue === 'DOWN') &&
          `
        background-color: #686868;
        `
        }
    `}
`;

const getImage = (str: string) => str.split('_')[1];
const windowMenuId = 'CATIZ_VideoPanel';
export function WindowsMenu(props: IWindowsMenuProps) {
  const { panelRows, buttonDict } = props;
  const dispatch = useDispatch();
  const doClick = (btnId: string) => {
    console.log('windows menu button clicked');
    dispatch(
      ComposedActions.PushWindowButton.aCreator({
        windowId: windowMenuId,
        buttonId: btnId,
      })
    );
    // dispatch(uiWindowBtnClickAC(windowMenuId, btnId));
  };
  return (
    <StyledWindowsMenu id={windowMenuId}>
      {panelRows.map((pRow) => {
        const panelButtons = pRow.buttonRefs;
        return (
          <RowContainer key={pRow.id}>
            {panelButtons.map((pButton) => {
              const btnObj = buttonDict[pButton];
              return (
                <StyledButton
                  key={btnObj.id}
                  onClick={() => doClick(btnObj.id)}
                  disabled={btnObj.defaultValue === 'OFFLINE'}
                  {...btnObj}
                >
                  <img
                    src={require(`../../../assets/images/${getImage(
                      btnObj.icon
                    )}.png`)}
                  />

                  <LabelContainer>{btnObj.label}</LabelContainer>
                </StyledButton>
              );
            })}
          </RowContainer>
        );
      })}
    </StyledWindowsMenu>
  );
}
